module.exports = __webpack_public_path__ + "assets/img/07-l.1be7a2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/07-l.jpg
// module id = muVv
// module chunks = 0